{
  "name": "@react-devtools-plus/scan",
  "type": "module",
  "version": "0.10.2",
  "description": "React Scan integration for React DevTools",
  "keywords": [
    "react",
    "react-devtools-plus",
    "react-scan",
    "performance",
    "profiler"
  ],
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js",
      "require": "./dist/index.cjs",
      "default": "./dist/index.js"
    },
    "./package.json": "./package.json"
  },
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "stub": "tsup --watch",
    "prepare:type": "tsc --declaration --emitDeclarationOnly --outDir dist"
  },
  "peerDependencies": {
    "@react-devtools-plus/core": "workspace:*",
    "react": "^16.8.0 || ^17.0.0 || ^18.0.0 || ^19.0.0",
    "react-dom": "^16.8.0 || ^17.0.0 || ^18.0.0 || ^19.0.0"
  },
  "peerDependenciesMeta": {
    "@react-devtools-plus/core": {
      "optional": true
    }
  },
  "dependencies": {
    "@preact/signals": "^1.3.1",
    "bippy": "^0.3.34",
    "clsx": "^2.1.1",
    "preact": "^10.25.1",
    "tailwind-merge": "^3.5.0"
  },
  "devDependencies": {
    "@types/react": "^18.2.72",
    "@types/react-dom": "^18.2.23",
    "esbuild": "^0.25.0",
    "tsup": "^8.0.0",
    "typescript": "^5.9.3"
  }
}
